<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    media: Object
  })

  const isImage = computed(() => {
    if (!props.media) return false

    if (props.media['element'].includes('image') || props.media['element'].includes('icon')) return true

    return false
  })

  const videoUrl = computed(() => {
    if (!props.media) return false
    if (props.media.props) {
      return props.media.props['video-file']
    }
    return props.media.videoUrl
  })

  const thumbnailUrl = computed(() => {
    if (!props.media) return false
    if (props.media.props) {
      return props.media.props['thumbnail-url']
    }
    return props.media.thumbnailUrl
  })
</script>

<template>
  <div
    class="media-item"
  >
    <img
      v-if="isImage"
      class="media-image w-full h-full object-cover"
      :src="props.media.imageUrl"
      :alt="props.media.imageAlt"
    />

  </div>
</template>

<style lang="scss">
</style>
